import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

export default function Footer() {
  const { isRTL } = useLanguage();

  return (
    <footer
      data-testid="site-footer"
      className="relative z-10 mt-16 border-t border-border bg-white/70 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-start">
        <div className="text-xs text-muted-foreground leading-relaxed">
          {isRTL
            ? "© 2026 مدرسة التمريض المصرية الألمانية (EGNS). جميع الحقوق محفوظة."
            : "© 2026 Egyptian German Nursing School (EGNS). All rights reserved."}
        </div>

        <a
          href="https://mimc.online"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-mimc-credit"
          className="group inline-flex items-center gap-3 rounded-full border border-border bg-white px-3 py-1.5 transition-all hover:-translate-y-0.5 hover:shadow-sm"
          aria-label="Created and developed by MIMC — Marzouk Integrated Marketing Communications"
        >
          <span className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
            {isRTL ? "تصميم وتطوير" : "Created & Developed by"}
          </span>
          <img
            src="/mimc-logo.jpeg"
            alt="MIMC — Marzouk Integrated Marketing Communications"
            className="h-6 w-6 rounded object-cover"
            loading="lazy"
          />
          <span className="flex flex-col leading-tight">
            <span className="text-xs font-semibold tracking-wide text-foreground group-hover:text-terracotta transition-colors">
              MIMC
            </span>
            <span className="text-[9px] text-muted-foreground hidden sm:inline">
              Marzouk Integrated Marketing Communications
            </span>
          </span>
          <span className="text-[10px] text-muted-foreground hidden sm:inline">© 2026</span>
        </a>
      </div>
    </footer>
  );
}
